<template>
  <div class="exhange-container">
    <div class="bg-accent-cool-lighter text-center padding-1">
      <div class="">{{translationKeywords['ex-rate'] || 'Exchange Rate'}}</div>
      <div class="grid-row flex-justify-center">
        <!-- Zubair, 29-Mar, currency exchange rate message Unavailable added, condition handling and code refactor -->
        <div class="grid-col-12 tablet:grid-col-6">
          <!-- Pooja, 11-mar-26, show proper html message not a text broken message -->
          <!-- Zubair, 26-Mar, currency exchange rate message Unavailable added, condition handling and code refactor -->
          {{translationKeywords['current-consular-exchange-rate'] || 'Current Consular Exchange Rate'}}: <span class="data-exchange-rate" v-if="exchangeRate && exchangeRate !== 'Unavailable' && currency"><span data-exchange-rate="1" data-exchange-rate-updated="true" v-html="exchangeRate"></span> {{ currency }} = 1 USD</span>
          <span v-if="(!exchangeRate || exchangeRate == 'Unavailable') || !currency">Unavailable</span>
        </div>
        <div class="grid-col-12 tablet:grid-col-6">
          {{translationKeywords['current-rate-valid-through'] || 'Current Rate Valid Through'}}: <span data-exchange-rate-date="" data-exchange-rate-date-updated="true" v-if="expiryDate" v-html="expiryDate"></span>
          <span v-if="!expiryDate">Unavailable</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getExchangeRate, getExchangeRateExpiry, getCurrencyCode, getTranslationKeywords } from "@/store/api";
import { urlCountryCode,urlLangCode } from "@/helpers/url";

export default {
  name: "exchange-rate-info-section",
  props: ["data"],
  data(){
    return{
      exchangeRate :  '',
      currency: '',
      expiryDate: '',
      currency: '',
      translationKeywords: {},
    }
  },
  created() {
    const countryCode = urlCountryCode();
    getCurrencyCode(countryCode).then(currency => this.currency = currency);
    getExchangeRate(countryCode).then(exchangeRate => this.exchangeRate = exchangeRate);
    getExchangeRateExpiry(countryCode).then(expiryDate => this.expiryDate = expiryDate);
  },
  beforeCreate() {
    getTranslationKeywords(urlLangCode()).then(
      (keywords) => (this.translationKeywords = keywords)
    );
  },
};
</script>
<style lang="scss" scoped>
  .exhange-container {
    margin: 20px 0 10px;
  }
</style>
